// ** Icons Import

import {
  Activity,
  Bell,
  CreditCard,
  DollarSign,
  Edit,
  Edit2,
  FilePlus,
  Home,
  Settings,
  Star,
  TrendingUp,
  User,
  Users,
} from "react-feather";
import DeliveryNotes from "../Icon/DeliveryNotes";
import Order from "../Icon/Order";
import SalesOrder from "../Icon/SalesOrder";
import Stock from "../Icon/Stock";
import { BiChat, BiPencil, BiTime } from "react-icons/bi";
export default [
  {
    id: "Reports",
    title: "Reports",
    icon: <Edit size={12} />,

    children: [
      {
        id: "Member Report",
        title: "Member Report",
        icon: <User size={12} />,
        action: "read",
        resource: "Doctype-4",
        navLink: "/Report/MemberReport",
      },
      {
        id: "Member Status",
        title: "Member Status",
        icon: <Users size={12} />,
        action: "read",
        resource: "Doctype-4",
        navLink: "/Report/MemberStatus",
      },
      {
        id: "Notification Report",
        title: "Notification Report",
        icon: <Bell size={12} />,
        action: "read",
        resource: "Doctype-4",
        navLink: "/Report/NotificationReport",
      },
      {
        id: "Talent Report",
        title: "Talent Report",
        icon: <Star size={12} />,
        action: "read",
        resource: "Doctype-4",
        navLink: "/Report/TalentReport",
      },
      {
        id: "Feedback Report",
        title: "Feedback Report",
        icon: <BiPencil size={12} />,
        action: "read",
        resource: "Doctype-4",
        navLink: "/Report/FeedbackReport",
      },
      {
        id: "WatchTime Report",
        title: "WatchTime Report",
        icon: <BiTime size={12} />,
        action: "read",
        resource: "Doctype-4",
        navLink: "/Report/WatchTimeReport",
      },
      {
        id: "Services Report",
        title: "Services Report",
        icon: <Settings size={12} />,
        action: "read",
        resource: "Doctype-4",
        navLink: "/Report/UserServices",
      },
      {
        id: "Chat Sessions",
        title: "Chat Sessions",
        icon: <BiChat size={12} />,
        action: "read",
        resource: "Doctype-4",
        navLink: "/Report/ChatSessions",
      },
    ],
  },
];
